<template>
<div class="row">
    <div class="col-md-4 lbl"><span class="small">{{$t('callQuality')}}:</span></div>
    <div class="col-md-8">
        <div class="progress">
           <div class="progress-bar progress-bar-striped progress-bar-animated" v-bind:aria-valuenow="vpNow" v-bind:aria-valuemin="vpMin" v-bind:aria-valuemax="vpMax" v-bind:style="style"></div>
        </div>
        <span class="small">&nbsp;&nbsp;{{'(' + percentWidth + ')'}}</span>
    </div>
</div>
    
</template>
<script>
export default {
    props: {
        vpMin: {
        type: Number,
        required: true
        },
        vpNow: {
        type: Number,
        required: true
        },
        vpMax: {
        type: Number,
        required: true
        }
    },
    computed: {
        percentWidth: function() {
        const range = this.vpMax - this.vpMin;
        const pos = this.vpNow - this.vpMin;
        return `${Math.round(100 * (pos / range))}%`;
        },
        style: function() {
        return {
            width: this.percentWidth,
            "background-color": this.getColorFromRange(parseInt(this.percentWidth.substr(0, this.percentWidth.length - 1)))
        };
        }
    },
    methods:{
        getColorFromRange(percStr){
            const num = percStr;
            let r = 0;
            let g = 0;
            let b = 0;
            const abs = Math.abs(num - 50);
                /* Red under 50 */
                if (num < 50) {
                r = 1;
                if (r > 0.5) {
                    g = 1 - (abs*0.02);
                }
                /* Green Over 50 */
                } else {
                g = 1;
                if (g > 0.5) {
                    r = 1 - (abs*0.02);
                }
                }
            r = this.limit(r, 0, 1);
            g = this.limit(g, 0, 1);
            b = this.limit(b, 0, 1);
            return `rgb(${Math.floor(r*255)},${Math.floor(g*255)},${Math.floor(b*255)})`;
        },
        limit(num, min, max){
            if (num < min) return min;
            if (num > max) return max;
            return num;
        }
    }
}
</script>
<style scoped>
    .progress{
        height: 5px;
        width: 60%;
        margin-top: 9px;
        float: left;
    }

    .lbl{
        margin-right: 0px !important;
        padding-right: 0px !important;
    }
</style>